import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { organization } from '../data/siteData';
import Reveal from './Reveal';
import { assetPath } from '../utils/assetPath';

const stories = [
  {
    image: assetPath('/assets/photos/482004702_1040535661453717_1902875297155302169_n.jpg'),
    label: 'Acompañamiento',
    title: 'Estar cerca también transforma.',
  },
  {
    image: assetPath('/assets/photos/537123962_1192205412952143_8381438350100508549_n.jpg'),
    label: 'Formación',
    title: 'Los valores se vuelven experiencia compartida.',
  },
  {
    image: assetPath('/assets/photos/504225618_3057210251109044_2487410118009274932_n.jpg'),
    label: 'Comunidad',
    title: 'Pequeños momentos, posibilidades más grandes.',
  },
  {
    image: assetPath('/assets/photos/504358165_3058480867648649_6609700657505944187_n.jpg'),
    label: 'Educación',
    title: 'Aprender juntos abre nuevos caminos.',
  },
  {
    image: assetPath('/assets/photos/504465484_3057860551044014_4665904954910063931_n.jpg'),
    label: 'Experiencias',
    title: 'Una comunidad que descubre, participa y crece.',
  },
];

export default function SocialCarousel() {
  const [active, setActive] = useState(0);
  const current = stories[active];

  const move = (direction) => {
    setActive((index) => (index + direction + stories.length) % stories.length);
  };

  return (
    <section className="social-section media-gallery-section" id="actualidad" aria-labelledby="gallery-title">
      <div className="shell">
        <Reveal className="media-gallery__heading">
          <div>
            <span className="eyebrow eyebrow--blue">Galería de impacto</span>
            <h2 id="gallery-title">Historias que se sienten antes de contarse.</h2>
          </div>
          <p>Una mirada cercana a las personas, los encuentros y los espacios que dan vida a Fundación Tony.</p>
        </Reveal>

        <Reveal className="media-gallery" delay={0.08}>
          <div className="media-gallery__stage">
            <AnimatePresence mode="wait" initial={false}>
              <motion.figure
                className="media-gallery__slide"
                key={current.image}
                initial={{ opacity: 0, scale: 1.025 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.985 }}
                transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
              >
                <img src={current.image} alt={current.title} />
                <figcaption>
                  <span>{current.label}</span>
                  <strong>{current.title}</strong>
                </figcaption>
              </motion.figure>
            </AnimatePresence>

            <div className="media-gallery__controls">
              <button type="button" onClick={() => move(-1)} aria-label="Imagen anterior"><ChevronLeft /></button>
              <span><b>{String(active + 1).padStart(2, '0')}</b> / {String(stories.length).padStart(2, '0')}</span>
              <button type="button" onClick={() => move(1)} aria-label="Siguiente imagen"><ChevronRight /></button>
            </div>
          </div>

          <div className="media-gallery__rail" aria-label="Seleccionar imagen">
            {stories.map((story, index) => (
              <button
                type="button"
                className={index === active ? 'is-active' : ''}
                key={story.image}
                onClick={() => setActive(index)}
                aria-label={`Ver imagen ${index + 1}: ${story.label}`}
                aria-current={index === active ? 'true' : undefined}
              >
                <img src={story.image} alt="" loading="lazy" />
                <span>{story.label}</span>
              </button>
            ))}
          </div>

          <div className="media-gallery__socials">
            <span>Sigue las historias más recientes</span>
            <a href={organization.facebook} target="_blank" rel="noreferrer">Facebook <ArrowUpRight /></a>
            <a href={organization.instagram} target="_blank" rel="noreferrer">Instagram <ArrowUpRight /></a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
